<script>
  import { Card } from 'attractions'
</script>

<Card outline>
  <div class="api command">addShootCommand(float angle, int power)</div>
  Causes the robot to shoot a game piece towards a target.
  <p>
    The robot will shoot a game piece at the specified angle and with the specified power. The angle is measured in
    degrees from the horizontal, with 90 degrees being straight up. The power is an integer value between 1 and 100,
    with higher values indicating a more powerful shot.
  </p>
  <div class="api title">Arguments:</div>
  <ul>
    <li><strong>angle</strong> &mdash; An float value representing the angle to shoot.</li>
    <li>
      <strong>power</strong> &mdash; An integer value to represent the power to shoot the game piece.
    </li>
  </ul>
  <div class="api title">Constraints:</div>
  <ul>
    <li>The angle must be a positive float between 0 and 90 (straight up).</li>
    <li>The power must be a positive integer between 1 and 100.</li>
  </ul>
  <div class="api title">Example:</div>
  <div class="api code">
    <pre>
      robot.addShootCommand(75, 25); /* Shoots the game piece at a 75 degree angle with 25 power */
      robot.addShootCommand(46.34, 50); /* Shoots the game piece at a 46.34 degree angle with 50 power */
    </pre>
  </div>
</Card>
